import { z } from 'zod';

/** Serialized KB article; DB timestamps are mapped to ISO strings by the service. */
export const kbArticleSchema = z.object({
  id: z.string().uuid(),
  category: z.string(),
  slug: z.string(),
  title: z.string(),
  summary: z.string().nullable(),
  content: z.string(),
  position: z.number().int(),
  is_default: z.boolean(),
  default_version: z.number().int(),
  updated_by: z.string().uuid().nullable(),
  updated_at: z.string().datetime(),
  created_at: z.string().datetime(),
});

export const kbArticleListResponseSchema = z.object({
  success: z.literal(true),
  data: z.array(kbArticleSchema),
});
export const kbArticleResponseSchema = z.object({
  success: z.literal(true),
  data: kbArticleSchema,
});
export const kbArticlePatchSchema = z.object({
  title: z.string().min(1).max(255).optional(),
  summary: z.string().optional(),
  content: z.string().optional(),
}).strict();

export type KbArticle = z.infer<typeof kbArticleSchema>;
export type KbArticlePatch = z.infer<typeof kbArticlePatchSchema>;
